import classNames from "classnames";
import React from "react";
import { isServer } from "../../utils/detection";
import { IconButton, Icomoon } from "../..";

import "./QuoteExpando.scss";

interface Props {
  question: string;
}

/**
 * Expando component.
 * 
 * @status review 
 * - hydration (this component could have a different first render on client and browser so could cause a tearing problem)
 * - naming (could be more generic; instead of "QuoteExpando" and "question", "Expando" and "label")
 * - code style (should be migrated to a functional component with hooks)
 * - design (default highlight style is using an old blue)
 */
export class QuoteExpando extends React.PureComponent<Props, { isOpen: boolean }> {
  public constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: isServer(),
    };
  }

  private toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

  public render() {
    return (
      <section className={classNames("quote-expando", { open: this.state.isOpen })}>
        <header onClick={this.toggleOpen}>
          <h3>{this.props.question}</h3>
          <IconButton
            icomoon={this.state.isOpen ? Icomoon.arrowUp3 : Icomoon.arrowDown3}
            onClick={this.toggleOpen}
          />
        </header>
        <div className="reply">
          {this.props.children}
        </div>
      </section>
    );
  }
}
